/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.09.2015
 * Copyright: xdot GmbH 2015
 */

import { AppContext, FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import { ModalActions } from 'plugin/base-portlet';

import StateValueWebApi from '../webapi/StateValueWebApi';
import { ClassNames } from '../constants/Constants';

const className = ClassNames.StateValue;

const api = 'StateValueWebApi';
const listApiMethod = 'loadStatesValuesFromService';
const itemApiMethod = '';

export default {

    list: (name, query) => RemoteDataActions.list(name, className, query, api + '.' + listApiMethod),

    attachedList: (name, query) => RemoteDataActions.list(name, className, query, api + '.' + listApiMethod),
    attachedItem: (name, byId, byClassName, query) => RemoteDataActions.attachedItem(name, className, api + '.' + itemApiMethod, byId, byClassName, query),

    moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query),

    createItem: (item, actionData) => FormActions.submitForm(StateValueWebApi.addStateValue, item, actionData).key,

    openStatusHistory: (state) => {
        ModalActions.showModal(ClassNames.StateValue, {
            byClassName: state.className,
            byId: state.classPK,
            byPropName: state.propName,
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE
        }, true, { state, size: "xl"});
    }

};



// WEBPACK FOOTER //
// ./js/actions/StateValueActions.js